import React from 'react';
import './WhyOrbix.css';

function WhyOrbix() {
  return (
    <section className="container mt-5 mt-md-4 my-lg-5 mb-2 mb-md-4">
      <div className="row pb-2">
        <div className="col-lg-10 col-md-10 mx-auto text-center ">
          <h2 className="h1 mb-4">Why Orbix <span className="text-primary fw-bold ">?</span></h2>
          <p className="fs-lg fw-semibold mb-4">
            We believe the systems people work within shape what they are able to achieve.
          </p>
          <p className="fs-lg mb-4">
            That is why Orbix is built to elevate inspection teams: preserving the real evidence,
            strengthening judgment, and making good work easier to carry out, verify, and defend.
          </p>
          <p className="fs-lg mb-0">
            Orbix is a platform for critical inspection operations, connecting imaging, inspection data,
            workflows, review, compliance, and AI-assisted quality oversight in one system.
          </p>
        </div>
      </div>
      <div className="text-nowrap mx-auto d-flex justify-content-center text-primary mt-3 mb-3 mt-sm-4 mb-sm-4 mt-md-5 mb-md-5 py-2">
          <i className="bx bx-down-arrow-circle me-2 fs-1"></i>
          <i className="bx bx-down-arrow-circle me-2 fs-1"></i>
          <i className="bx bx-down-arrow-circle me-2 fs-1"></i>                   
      </div>

      <div className="row">
        <div className="col-lg-10 col-md-10 mx-auto text-center">
          <h3 className="h5 mb-4">Enter Orbix</h3>
          <h2 className="h1 mb-4">One system for <span className="text-primary fw-bold ">critical inspection operations</span></h2>
          <p className="fs-lg mb-0">
          Orbix brings the full inspection operation into one platform: imaging, inspection data, workflows, review, compliance, and AI-assisted quality oversight.
          </p>
        </div>
      </div>
    
      <div className="pt-5 pb-2 pb-md-3 ">
        <div className="row align-items-center justify-content-center my-3 py-md-3 py-lg-5">
          <div className="col-12 col-sm-10 col-md-6 col-lg-6 col-xl-6  order-md-2 mb-4 mb-md-0 pb-4 pb-md-0">
            <div className="position-relative mx-auto mx-md-0">
                <img className="img-fluid w-100" src="/assets/home_page/v3/images/why_orbix.png" alt="Screen" />
            </div>
          </div>
          <div className="col-10 col-sm-10 col-md-6 col-lg-5 col-xl-4 order-md-1 pb-2 pb-md-4 ps-md-3 ps-lg-4 ps-xl-5">
           
            <ul className="list-unstyled">
                <li className="d-flex align-items-center mb-2 mb-lg-3">
                <i className="bx bx-check-circle fs-xl text-primary me-2 flex-shrink-0"></i>
                <span className=" text-start fs-sm ">Run inspection workflows in real time</span>
              </li>
              <li className="d-flex align-items-center mb-2 mb-lg-3">
                <i className="bx bx-check-circle fs-xl text-primary me-2 flex-shrink-0"></i>
                <span className=" text-start fs-sm ">Keep evidence connected to every decision
                </span>
              </li>
              <li className="d-flex align-items-center mb-2 mb-lg-3">
                <i className="bx bx-check-circle fs-xl text-primary me-2 flex-shrink-0"></i>
                <span className=" text-start fs-sm ">Surface exceptions before they become problems
                </span>
              </li>
              <li className="d-flex align-items-center">
                <i className="bx bx-check-circle fs-xl text-primary me-2 flex-shrink-0"></i>
                <span className=" text-start fs-sm ">Maintain visibility across projects and teams</span>
              </li>
            </ul>
          
          </div>
        </div>
      
        {/* Extra spacing for dark mode only */}
        <div className="pt-5 d-none d-dark-mode-block"></div>
      </div>
    </section>
  );
}

export default WhyOrbix;

